import { EventDateType } from "globals/types/models.ts";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import dayjs from "dayjs";
import Icon from "components/atom/Icon.tsx";

function EventDateListItem(props: { date: EventDateType, hideIconLabel?: boolean }) {
  const { date, hideIconLabel = false } = props;
  const { t } = useTranslation();

  const startDateStr = useMemo(() => {
    if (!date) return null;
    if (!date.startDate) return null;

    return dayjs(date.startDate).format("D MMM YYYY HH:mm");
  }, [date]);

  const endDateStr = useMemo(() => {
    if (!date) return null;
    if (!date.endDate) return null;

    const endDateDayJs = dayjs(date.endDate);

    if (date.startDate) {
      const startDateDayJs = dayjs(date.startDate);
      if (startDateDayJs.isSame(endDateDayJs, "day")) {
        const endDateStr = endDateDayJs.format("HH:mm");
        if (endDateStr === "00:00") {
          return null;
        }
        return endDateStr
      }
    }

    return endDateDayJs.format("D MMM YYYY HH:mm");
  }, [date]);


  return (
    <li className="w-full flex flex-row items-center justify-start gap-1">
      <dl
        className="w-full flex flex-row items-center justify-start gap-2"
      >
        <dt
          className={`flex flex-row items-center justify-start gap-1 text-base text-gray-400 font-normal ${hideIconLabel ? "" : "w-20"}`}>
          <Icon name="calendar" className="h-4 w-4 min-w-4 text-gray-400" />
          {!hideIconLabel && (
            <span className="text-xs">
              {t("event.date")}
            </span>
          )}
        </dt>
        <dd className="text-base text-gray-600 flex-1">
          {startDateStr}{endDateStr ? ` - ${endDateStr}` : ""}
        </dd>
      </dl>
    </li>
  );
}

export default EventDateListItem;
